import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { TYPES } from '@antv/l7-core';
import { lngLatInExtent } from '@antv/l7-utils';

var BaseLayerPickService = /*#__PURE__*/function () {
  function BaseLayerPickService(layer) {
    _classCallCheck(this, BaseLayerPickService);

    this.layer = layer;
  }

  _createClass(BaseLayerPickService, [{
    key: "pickRender",
    value: function pickRender(target) {
      var layer = this.layer; // 瓦片图层的拾取绘制

      if (layer.tileLayer) {
        return layer.tileLayer.pickRender(target);
      }

      layer.hooks.beforePickingEncode.call();

      if (layer.masks.length > 0) {
        // 若存在 mask，则在 pick 阶段的绘制也启用
        layer.masks.filter(function (mask) {
          return mask.inited;
        }).forEach( /*#__PURE__*/function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(m) {
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    m.render();

                  case 1:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      }

      layer.renderModels(true);
      layer.hooks.afterPickingEncode.call();
    }
  }, {
    key: "pick",
    value: function pick(layer, target) {
      var container = this.layer.getContainer();
      var pickingService = container.get(TYPES.IPickingService);

      if (layer.type === 'RasterLayer') {
        return this.pickRasterLayer(layer, target);
      }

      this.pickRender(target);
      return pickingService.pickFromPickingFBO(layer, target);
    }
  }, {
    key: "pickRasterLayer",
    value: function pickRasterLayer(layer, target, parent) {
      var container = this.layer.getContainer();
      var pickingService = container.get(TYPES.IPickingService);
      var mapService = container.get(TYPES.IMapService);
      var extent = this.layer.getSource().extent;
      var isPick = lngLatInExtent(target.lngLat, extent);
      var layerTarget = {
        x: target.x,
        y: target.y,
        type: target.type,
        lngLat: target.lngLat,
        target: target,
        rasterValue: null
      };
      var adviceTarget = parent ? parent : layer;

      if (isPick) {
        var rasterValue = this.readRasterValue(layer, extent, mapService, target.x, target.y);
        layerTarget.rasterValue = rasterValue;
        pickingService.triggerHoverOnLayer(adviceTarget, layerTarget);
        return true;
      } else {
        layerTarget.type = target.type === 'mousemove' ? 'mouseout' : 'un' + target.type;
        pickingService.triggerHoverOnLayer(adviceTarget, _objectSpread(_objectSpread({}, layerTarget), {}, {
          type: 'unpick'
        }));
        pickingService.triggerHoverOnLayer(adviceTarget, layerTarget);
        return false;
      }
    }
  }, {
    key: "readRasterValue",
    value: function readRasterValue(layer, bbox, mapService, x, y) {
      var rasterData = layer.getSource().data.dataArray[0];

      var _bbox = _slicedToArray(bbox, 4),
          _bbox$ = _bbox[0],
          minLng = _bbox$ === void 0 ? 0 : _bbox$,
          _bbox$2 = _bbox[1],
          minLat = _bbox$2 === void 0 ? 0 : _bbox$2,
          _bbox$3 = _bbox[2],
          maxLng = _bbox$3 === void 0 ? 10 : _bbox$3,
          _bbox$4 = _bbox[3],
          maxLat = _bbox$4 === void 0 ? -10 : _bbox$4;

      var tileXY = mapService.lngLatToContainer([minLng, minLat]);
      var tileMaxXY = mapService.lngLatToContainer([maxLng, maxLat]);
      var tilePixelWidth = tileMaxXY.x - tileXY.x;
      var tilePixelHeight = tileXY.y - tileMaxXY.y;
      var pos = [(x - tileXY.x) / tilePixelWidth, // x
      (y - tileMaxXY.y) / tilePixelHeight // y
      ];
      var tileWidth = rasterData.width || 1;
      var tileHeight = rasterData.height || 1;
      var indexX = Math.floor(pos[0] * tileWidth);
      var indexY = Math.floor(pos[1] * tileHeight);
      var index = Math.max(0, indexY - 1) * tileWidth + indexX;
      var data = rasterData.data[index];
      return data;
    }
  }, {
    key: "selectFeature",
    value: function selectFeature(pickedColors) {
      var layer = this.layer; // @ts-ignore

      var _pickedColors = _slicedToArray(pickedColors, 3),
          r = _pickedColors[0],
          g = _pickedColors[1],
          b = _pickedColors[2];

      layer.hooks.beforeSelect.call([r, g, b]);
    }
  }, {
    key: "highlightPickedFeature",
    value: function highlightPickedFeature(pickedColors) {
      // @ts-ignore
      var _pickedColors2 = _slicedToArray(pickedColors, 3),
          r = _pickedColors2[0],
          g = _pickedColors2[1],
          b = _pickedColors2[2];

      this.layer.hooks.beforeHighlight.call([r, g, b]);
    }
  }, {
    key: "getFeatureById",
    value: function getFeatureById(pickedFeatureIdx) {
      return this.layer.getSource().getFeatureById(pickedFeatureIdx);
    }
  }]);

  return BaseLayerPickService;
}();

export { BaseLayerPickService as default };